import React, { useRef, useEffect, useState } from "react";
import { ChevronRight } from "lucide-react";

const AccordionItem = ({ handleToggle, active, faq, index }) => {
  const contentEl = useRef(null);
  const { header, id, text } = faq;
  const [height, setHeight] = useState("0px");
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    if (active === id && contentEl.current) {
      setHeight(`${contentEl.current.scrollHeight}px`);
    } else {
      setHeight("0px");
    }
  }, [active, id]);

  const isActive = active === id;

  return (
    <div 
      className={`
        relative overflow-hidden rounded-2xl transition-all duration-500 ease-out
        ${isActive 
          ? 'bg-gradient-to-br from-blue-50 to-indigo-50 shadow-2xl shadow-blue-100/50 border-2 border-blue-100' 
          : 'bg-white shadow-lg shadow-gray-100/50 border border-gray-100 hover:shadow-xl hover:shadow-blue-100/30'
        }
        ${isHovered ? 'transform scale-[1.01]' : ''}
      `}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Animated background gradient */}
      <div className={`
        absolute inset-0 bg-gradient-to-r from-blue-500/5 to-blue-400/5 
        transition-opacity duration-500 ${isActive ? 'opacity-100' : 'opacity-0'}
      `}></div>
      
      {/* Left accent line */}
      
      <div className="relative  hover:border-blue-600 border rounded-2xl ">
        <div
          className={`
            p-6 flex justify-between items-center  cursor-pointer transition-all duration-300
            ${isActive ? 'pb-4' : ''}
          `}
          onClick={() => handleToggle(id)}
        >
          <div className="flex items-start space-x-4  flex-1">
            {/* Question number indicator */}
           
            
            <h2 className={`
              flex-1 font-medium  leading-relaxed transition-all duration-300
              ${isActive 
                ? 'text-xl text-gray-800 font-semibold' 
                : 'text-lg text-gray-700 hover:text-gray-900'
              }
            `}>
              {header}
            </h2>
          </div>
          
          <div className="flex-shrink-0 ml-4">
            <div className={`rounded-full flex items-center justify-center
              transition-all duration-300
             
            `}>
              <ChevronRight
                className={`
                  w-6 h-6 transition-all duration-300 ease-in-out
                  ${isActive ? 'rotate-90' : 'rotate-0'}
                `}
              />
            </div>
          </div>
        </div>
        
        <div
          ref={contentEl}
          className="overflow-hidden transition-all duration-500 ease-out"
          style={{ height }}
        >
          <div className=" pb-6 h-auto">
            <div className=" px-6 pb-20 md:pb-8 text-xs md:text-base">
              <div className={`
                text-gray-600 leading-relaxed transition-all duration-300
                ${isActive ? 'text-[14px]' : 'text-sm'}
              `}>
                <div className="prose prose-gray max-w-none">
                  {text}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Bottom border animation */}
      <div className={`
        absolute bottom-0 left-0 right-0 h-0.5 bg-gradient-to-r from-blue-500 to-[#058BF0]
        transition-all duration-500 ${isActive ? 'opacity-100' : 'opacity-0'}
      `}></div>
    </div>
  );
};

export default AccordionItem;
